import { addAlert } from '../../../MsgNotify/msgNotifyActions';
import { httpPost, httpGet, httpPut, httpDelete } from '../../../Util/http';
import { routeActions } from 'redux-simple-router';

export const CREATE_WORKPLACE_SUCCESS = 'CREATE_WORKPLACE_SUCCESS'
export function createWorkplaceSuccess(updatedWorkplace) {
    return {
        type: CREATE_WORKPLACE_SUCCESS,
        updatedWorkplace: updatedWorkplace
    };
}

export const EDIT_CREATE_WORKPLACE_FAILURE = 'EDIT_CREATE_WORKPLACE_FAILURE'
export function editCreateWorkplaceFailure() {
    return {
        type: EDIT_CREATE_WORKPLACE_FAILURE
    };
}

export const EDIT_CREATE_WORKPLACE_REQUEST = 'EDIT_CREATE_WORKPLACE_REQUEST';
export function editCreateWorkplaceRequest() {
    return {
        type: EDIT_CREATE_WORKPLACE_REQUEST
    }
}

export const EDIT_WORKPLACE_SUCCESS = 'EDIT_WORKPLACE_SUCCESS'
export function editWorkplaceSuccess(updatedWorkplace) {
    return {
        type: EDIT_WORKPLACE_SUCCESS,
        updatedWorkplace: updatedWorkplace
    };
}



export function attemptCreateEditWorkplace(departmentId, payload, workplaceId, headsub) {
    //create the url for create or edit
    let endOfUrl = workplaceId ? workplaceId : "";
    let _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + endOfUrl
    let finalPayload = {
        name: payload.workplace.name
    }
    // headsub = headsub.map((e) => {
    //     if (!e || !e.heading || !e.subtext) {
    //     } else {
    //         return e
    //     }
    // })
    //if its a create, add departmentId to the payload
    if (!workplaceId) {
        finalPayload.departmentId = departmentId
    }
    return (dispatch) => {
        dispatch(editCreateWorkplaceRequest());
        getProjectId(payload.project, departmentId)
            .then(projectId => {
                finalPayload.projectId = projectId;
                return getFullClient(payload.client)
            })
            .then((client) => {
                finalPayload.contactId = client.contact.id
                finalPayload.clientId = client.id;
                return workplaceId ? httpPut(_url, finalPayload) : httpPost(_url, finalPayload)
            })
            .then(response => {
                return workplaceId ? workplaceId : response.json();
            })
            .then(id => {
                return httpPost(process.env.REACT_APP_webApiEndPoint + 'api/workplaceExtended/save' + `?id=${id}&c=${JSON.stringify(headsub)}`)
                    .then(() => id)
                    .catch(() => id)
            })
            .then(id => {
                let updatedWorkplace = {
                    name: payload.workplace.name,
                    id: id,
                    project: {
                        id: finalPayload.projectId,
                        number: payload.project.number,
                        name: payload.project.name
                    },
                    client: {
                        name: payload.client.name,
                        id: finalPayload.clientId,
                        contact: {
                            name: payload.client.contact.name,
                            id: finalPayload.contactId
                        }
                    },
                    headsub: headsub
                }
                if (!workplaceId) {
                    dispatch(createWorkplaceSuccess(updatedWorkplace))
                    dispatch(routeActions.push("/afdeling/" + departmentId + "/arbejdssted/" + id + "/oversigt"))
                }
                else {
                    dispatch(editWorkplaceSuccess(updatedWorkplace))
                }
            })
            .catch((e) => {
                console.error(e)
                dispatch(editCreateWorkplaceFailure())
                dispatch(addAlert("Kunne ikke oprette/redigere arbejdssted"))
            })

    };
}

//method for either ceating a new projet or simply retuning the id needed for final save
const getProjectId = (project, departmentId) => {
    let _url = process.env.REACT_APP_webApiEndPoint + 'api/project/' + departmentId;
    if (!project.id) {
        return httpPost(_url, { name: project.name, number: project.number })
            .then(response => {
                return response.json();
            })
    }
    else {
        return new Promise((resolve) => {
            resolve(project.id);
        })
    }
}

//method for either creating new client, new contact on client or returning the chosen contactId on the client
const getFullClient = (client) => {
    let _url_createClient = process.env.REACT_APP_webApiEndPoint + 'api/client/';
    let _url_createContact = process.env.REACT_APP_webApiEndPoint + 'api/client/contact/';
    //if client has no id, both needs to be created in a promise chain
    if (!client.id) {
        return httpPost(_url_createClient, { name: client.name })
            .then(response => {
                return response.json();
            })
            .then((clientId) => {
                client.id = clientId
                return httpPost(_url_createContact, { contactName: client.contact.name, clientId: clientId });
            })
            .then(response => {
                return response.json();
            })
            .then(clientId => {
                client.contact.id = clientId
                return client;
            })
    }
    //else if contact doesnt have an id, it needs to be created
    else if (!client.contact.id) {
        return httpPost(_url_createContact, { contactName: client.contact.name, clientId: client.id })
            .then(response => {
                return response.json();
            })
            .then(clientId => {
                client.contact.id = clientId
                return client;
            })
    }
    //else return the contact id
    else {
        return new Promise((resolve) => {
            resolve(client);
        })
    }
}

export const GET_WORKPLACE_REQUEST = 'GET_WORKPLACE_REQUEST';
export function getWorkplaceRequest() {
    return {
        type: GET_WORKPLACE_REQUEST
    }
}

export const GET_WORKPLACE_SUCCESS = 'GET_WORKPLACE_SUCCESS';
export function getWorkplaceSuccess(workplace) {
    return {
        type: GET_WORKPLACE_SUCCESS,
        workplace: workplace
    };
}

export const GET_WORKPLACE_FAILURE = 'GET_WORKPLACE_FAILURE'
export function getWorkplaceFailure() {
    return {
        type: GET_WORKPLACE_FAILURE
    };
}

export const DELETE_WORKPLACE_REQUEST = 'DELETE_WORKPLACE_REQUEST';
export function deleteWorkplaceRequest(workplaceId) {
    return {
        type: DELETE_WORKPLACE_REQUEST,
        workplaceId: workplaceId
    };
}

export const DELETE_WORKPLACE_SUCCESS = 'DELETE_WORKPLACE_SUCCESS';
export function deleteWorkplaceSuccess() {
    return {
        type: DELETE_WORKPLACE_SUCCESS
    };
}

export function attemptDeleteWorkplace(workplaceId, departmentId) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + workplaceId;
    return (dispatch) => {
        dispatch(deleteWorkplaceRequest(workplaceId))
        return httpDelete(_url)
            .then(() => {
                setTimeout(() => {
                    deleteWorkplaceSuccess()
                    dispatch(routeActions.push("/afdeling/" + departmentId))
                }, 3000);
            })
    };
}
const suggestions = [
    { heading: 'Faktura adresse', subtext: '', editMode: true },
    { heading: 'Faktura mail', subtext: '', editMode: true },
    { heading: 'CVR', subtext: '', editMode: true },
    { heading: 'EAN', subtext: '', editMode: true },
    { heading: 'Kundens projektnr', subtext: '', editMode: true },
    { heading: 'Betalingsbetingelser', subtext: '', editMode: true },
]
function getHeadSubAndSuggestions(headsub) {
    let hs = headsub ? headsub : [{ heading: '', subtext: '', editMode: true }]
    let add = []
    suggestions.forEach((s) => {
        let found = false
        hs.forEach((h) => {
            if (h && h.heading === s.heading) {
                found = true
            }
        })
        if (!found) {
            add.push(s)
        }
    })
    return hs.concat(add)
}

export function attemptGetWorkplace(departmentId, workplaceId) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + workplaceId;
    return (dispatch) => {
        dispatch(getWorkplaceRequest())
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                return httpGet(process.env.REACT_APP_webApiEndPoint + '/api/workplaceExtended/get?id=' + workplaceId)
                    .then(r => r.json())
                    .then(r => {
                        json.headsub = getHeadSubAndSuggestions(JSON.parse(r.content))
                        return json
                    })
                    .catch(() => {
                        json.headsub = getHeadSubAndSuggestions([{ heading: '', subtext: '', editMode: true }])
                        return json
                    })
            })
            .then(json => {
                dispatch(getWorkplaceSuccess(json))
            })
            .catch(() => {
                dispatch(getWorkplaceFailure())
                dispatch(routeActions.push("/afdeling/" + departmentId))
                dispatch(addAlert("Kunne ikke hente arbejdssted"))
            })
    };
}

export const GET_DAILY_REPORTS_REQUEST = 'GET_DAILY_REPORTS_REQUEST';
export function getDailtyReportsRequest() {
    return {
        type: GET_DAILY_REPORTS_REQUEST
    }
}


export const GET_DAILY_REPORTS_SUCCESS = 'GET_DAILY_REPORTS_SUCCESS'
export function getDailtyReportsSuccess(json, approvementCount, skip, oldSkip) {

    //make the date from string to date Object
    let dailyReports = []
    json.forEach((dailyReport) => {
        let newDailyReport = { ...dailyReport }
        newDailyReport.date = new Date(dailyReport.date)
        dailyReports.push(newDailyReport);
    })

    return {
        type: GET_DAILY_REPORTS_SUCCESS,
        dailyReports: dailyReports,
        approvementCount: approvementCount,
        dailyReportsSkip: skip,
        oldSkip: oldSkip
    };
}


export const GET_DAILY_REPORTS_SUCCESS_INIT = 'GET_DAILY_REPORTS_SUCCESS_INIT'
export function getDailtyReportsSuccessInit(json, approvementCount, skip, oldSkip) {

    //make the date from string to date Object
    let dailyReports = []
    json.forEach((dailyReport) => {
        let newDailyReport = { ...dailyReport }
        newDailyReport.date = new Date(dailyReport.date)
        dailyReports.push(newDailyReport);
    })

    return {
        type: GET_DAILY_REPORTS_SUCCESS_INIT,
        dailyReports: dailyReports,
        approvementCount: approvementCount,
        dailyReportsSkip: skip,
        oldSkip: oldSkip
    };
}

export const GET_DAILY_REPORTS_FAILURE = 'GET_DAILY_REPORTS_FAILURE'
export function getDailtyReportsFailure() {
    return {
        type: GET_DAILY_REPORTS_FAILURE
    };
}

export function attemptGetDailyReports(workplaceId, isInit) {

    return (dispatch, getState) => {

        let currentSkip = isInit ? 0 : getState().workplaceOverviewReducer.dailyReports.length;
        let take = 20;

        var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreports/' + workplaceId + "?skip=" + currentSkip + "&take=" + take
        dispatch(getDailtyReportsRequest())
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                if (isInit)
                    dispatch(getDailtyReportsSuccessInit(json.dailyreports, json.approvementCount, currentSkip + take, currentSkip))
                else
                    dispatch(getDailtyReportsSuccess(json.dailyreports, json.approvementCount, currentSkip + take, currentSkip))
            })
            .catch(() => {
                dispatch(getDailtyReportsFailure())
                dispatch(addAlert("Kunne ikke hente dagsrapporter"))
            })
    };
}




export const DAILY_REPORT_TOGGLE_APPROVED_REQUEST = 'DAILY_REPORT_TOGGLE_APPROVED_REQUEST';
export function dilyReportToggleApprovedRequest(dailyReportIndex, approved) {
    return {
        type: DAILY_REPORT_TOGGLE_APPROVED_REQUEST,
        dailyReportIndex: dailyReportIndex,
        approved: approved
    }
}

export const DAILY_REPORT_TOGGLE_APPROVED_SUCCESS = 'DAILY_REPORT_TOGGLE_APPROVED_SUCCESS'
export function dilyReportToggleApprovedSuccess(newApprovementCount) {
    return {
        type: DAILY_REPORT_TOGGLE_APPROVED_SUCCESS,
        approvementCount: newApprovementCount
    };
}

export const DAILY_REPORT_TOGGLE_APPROVED_FAILURE = 'DAILY_REPORT_TOGGLE_APPROVED_FAILURE'
export function dilyReportToggleApprovedFailure(dailyReportIndex, approved) {
    return {
        type: DAILY_REPORT_TOGGLE_APPROVED_FAILURE,
        dailyReportIndex: dailyReportIndex,
        approved: approved
    };
}

export const DAILY_REPORT_TOGGLE_BOG_REQUEST = 'DAILY_REPORT_TOGGLE_BOG_REQUEST';
export function dilyReportToggleBogRequest(dailyReportIndex, bog) {
    return {
        type: DAILY_REPORT_TOGGLE_BOG_REQUEST,
        dailyReportIndex: dailyReportIndex,
        bog: bog
    }
}

export const DAILY_REPORT_TOGGLE_BOG_SUCCESS = 'DAILY_REPORT_TOGGLE_BOG_SUCCESS'
export function dilyReportToggleBogSuccess(newApprovementCount) {
    return {
        type: DAILY_REPORT_TOGGLE_BOG_SUCCESS,
        approvementCount: newApprovementCount
    };
}

export const DAILY_REPORT_TOGGLE_BOG_FAILURE = 'DAILY_REPORT_TOGGLE_BOG_FAILURE'
export function dilyReportToggleBogFailure(dailyReportIndex, bog) {
    return {
        type: DAILY_REPORT_TOGGLE_BOG_FAILURE,
        dailyReportIndex: dailyReportIndex,
        bog: bog
    };
}

export const DAILY_REPORT_TOGGLE_INVOICED_REQUEST = 'DAILY_REPORT_TOGGLE_INVOICED_REQUEST';
export function dilyReportToggleInvoicedRequest(dailyReportIndex, invoiced) {
    return {
        type: DAILY_REPORT_TOGGLE_INVOICED_REQUEST,
        dailyReportIndex: dailyReportIndex,
        invoiced: invoiced
    }
}

export const DAILY_REPORT_TOGGLE_INVOICED_SUCCESS = 'DAILY_REPORT_TOGGLE_INVOICED_SUCCESS'
export function dilyReportToggleInvoicedSuccess() {
    return {
        type: DAILY_REPORT_TOGGLE_INVOICED_SUCCESS
    };
}

export const DAILY_REPORT_TOGGLE_INVOICED_FAILURE = 'DAILY_REPORT_TOGGLE_INVOICED_FAILURE'
export function dilyReportToggleInvoicedFailure(dailyReportIndex, invoiced) {
    return {
        type: DAILY_REPORT_TOGGLE_INVOICED_FAILURE,
        dailyReportIndex: dailyReportIndex,
        invoiced: invoiced
    };
}

export function attemptDailyReportToggleApproved(dailyReportIndex, dailyReportId, approved) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/approve';
    return (dispatch, getState) => {
        dispatch(dilyReportToggleApprovedRequest(dailyReportIndex, approved))
        return httpPut(_url, { approved: approved, id: dailyReportId })
            .then(() => {
                //update the approved
                let approvementCount = getState().workplaceOverviewReducer.approvementCount;
                let newApprovementCount = {
                    approved: approved ? approvementCount.approved + 1 : approvementCount.approved - 1,
                    notApproved: approved ? approvementCount.notApproved - 1 : approvementCount.notApproved + 1
                }
                dispatch(dilyReportToggleApprovedSuccess(newApprovementCount))
            })
            .catch(() => {
                dispatch(dilyReportToggleApprovedFailure(dailyReportIndex, !approved))
                dispatch(addAlert("Kunne opdatere dagrapport status"))
            })
    };
}

export function attemptDailyReportToggleInvoiced(dailyReportIndex, dailyReportId, invoiced) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/invoiced';
    return (dispatch) => {
        dispatch(dilyReportToggleInvoicedRequest(dailyReportIndex, invoiced))
        return httpPut(_url, { invoiced: invoiced, id: dailyReportId })
            .then(() => {
                dispatch(dilyReportToggleInvoicedSuccess())
            })
            .catch(() => {
                dispatch(dilyReportToggleInvoicedFailure(dailyReportIndex, !invoiced))
                dispatch(addAlert("Kunne opdatere dagrapport status"))
            })
    };
}

export function attemptDailyReportToggleBog(dailyReportIndex, dailyReportId, bog) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/bog';
    return (dispatch) => {
        dispatch(dilyReportToggleBogRequest(dailyReportIndex, bog))
        return httpPut(_url, { bog: bog, id: dailyReportId })
            .then(() => {
                dispatch(dilyReportToggleBogSuccess())
            })
            .catch(() => {
                dispatch(dilyReportToggleBogFailure(dailyReportIndex, !bog))
                dispatch(addAlert("Kunne opdatere dagrapport status"))
            })
    };
}




export const WORKPLACE_IS_PROJECTNUMBER_RESERVED_SUCCESS = 'WORKPLACE_IS_PROJECTNUMBER_RESERVED_SUCCESS';
export function isProjectNumberReservedSuccess(projectNumberReserved) {
    return {
        type: WORKPLACE_IS_PROJECTNUMBER_RESERVED_SUCCESS,
        projectNumberReserved: projectNumberReserved
    }
}

export function isProjectNumberReserved(projectNumber) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project/reserved/" + projectNumber
    return (dispatch) => {
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                dispatch(isProjectNumberReservedSuccess({ projectNumber: projectNumber, reserved: json }))
            })
            .catch(() => {

            })
    };
}


export const GET_PROJECT_SUGGESTIONS_SUCCESS = 'GET_PROJECT_SUGGESTIONS_SUCCESS';
export function getProjectSuggestionsSuccess(suggestions) {
    return {
        type: GET_PROJECT_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}

export function getProjectSuggestions(val) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project/search?query=" + val + "&all=true";
    return (dispatch) => {
        if (!val) {
            dispatch(getProjectSuggestionsSuccess([]))
            return;
        }
        //Dummy data
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                dispatch(getProjectSuggestionsSuccess(json))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}



export const GET_CLIENT_SUGGESTIONS_SUCCESS = 'GET_CLIENT_SUGGESTIONS_SUCCESS';
export function getClientSuggestionsSuccess(suggestions) {
    return {
        type: GET_CLIENT_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}

export function getClientSuggestions(val) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "/api/client/search?query=" + val
    return (dispatch) => {
        if (!val) {
            dispatch(getClientSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                dispatch(getClientSuggestionsSuccess(json))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}

export const ADD_HEADINGSUBTEXT_WORX = 'ADD_HEADINGSUBTEXT_WORX';
export function addHeadingSubtext_worx() {
    return {
        type: ADD_HEADINGSUBTEXT_WORX,
        headingSubtextObj: { heading: '', subtext: '', editMode: true }
    }
}

export const UPDATE_HEADING_WORX = 'UPDATE_HEADING_WORX';
export function updateHeading_worx(text, index) {
    return {
        type: UPDATE_HEADING_WORX,
        index,
        text
    }
}

export const UPDATE_SUBTEXT_WORX = 'UPDATE_SUBTEXT_WORX';
export function updateSubtext_worx(text, index) {
    return {
        type: UPDATE_SUBTEXT_WORX,
        index,
        text
    }
}


export const GET_CONTACT_SUGGESTIONS_SUCCESS = 'GET_CONTACT_SUGGESTIONS_SUCCESS';
export function getContactSuggestionsSuccess(suggestions) {
    return {
        type: GET_CONTACT_SUGGESTIONS_SUCCESS,
        suggestions
    }
}

export function getContactSuggestions(val, clientId) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/client/" + clientId + "/contact/search?query=" + val
    return (dispatch) => {
        if (!val) {
            dispatch(getContactSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                dispatch(getContactSuggestionsSuccess(json))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}


export const WORKPLACE_OVERVIEW_SET_INIT_STATE = 'WORKPLACE_OVERVIEW_SET_INIT_STATE';
export function setInitState() {
    return {
        type: WORKPLACE_OVERVIEW_SET_INIT_STATE
    }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/actions.js